export const iconFilledClassName = "fui-Icon-filled";
export const iconRegularClassName = "fui-Icon-regular";
export const iconLightClassName = "fui-Icon-light";
export const iconColorClassName = "fui-Icon-color";
export const fontIconClassName = "fui-Icon-font";
